<template>
  <div class="notify-card">
    <div class="header-notify">
      <span class="notify-type">
        <img src="https://storage.googleapis.com/wp-bucket-tcc/channel/images/warning-triangle.svg" alt="warning-triangle">
        {{ data.type == "Novedades" ? 'Novedad' : 'Notificación'}}
      </span>
      <div class="close-notify" @click="closeCard">
        <img src="https://storage.googleapis.com/wp-bucket-tcc/channel/images/close-big.svg" alt="close">
      </div>
    </div>
    <div class="body-notify">
      <strong>{{ title }}</strong>
      <span>{{ message }}</span>
      <div class="action-notify" @click="gotoAction">{{ defineTitle }}</div>
    </div>
  </div>
</template>

<script>
  import { notyService } from "@/services/notificationsService";

  export default {
    props: ['id', 'title', 'message', 'data', 'documentNumber'],
    inject: {
      updateNotifications: { default: () => () => {} }
    },
    computed:{
      defineTitle(){
        let type = '';
        switch (this.data.type.toUpperCase()) {
          case this.recaudosIni.toUpperCase():
            type= 'Crear una guía'
            break;
          case this.recaudos.toUpperCase():
            type= 'Ver pagos'
            break;
          case this.novedades.toUpperCase():
            type= 'Ver novedad'
              break;
          case this.facturas.toUpperCase():
            type= 'Ver factura'
              break;
          case this.recogidas.toUpperCase():
            type= 'Ver recogida'
              break;
        }
        return type
      }
    },
    data: ()=>({
      recaudosIni: 'RecaudosIni',
      recaudos: 'Recaudos',
      novedades: 'Novedades',
      facturas: 'Facturas',
      recogidas: 'Recogidas'
    }),
    methods: {
      // Cierra la tarjeta sin marcar como leída; la notificación persiste en el contador del menú
      closeCard() {
        this.$emit('closeOverlay');
      },
      // Marks the notification as read on click and redirects to the target module.
      // Not awaited so the redirect isn't delayed; the service logs any error.
      gotoAction() {
        this.$emit('closeOverlay');
        notyService.markAsRead({ id: this.id, documentNumber: this.documentNumber });
        this.updateNotifications(this.id);
        this.redirectPage(this.data.id, this.data.type.toLowerCase());
      },
      setUrlRedirect(){
        let url = '';
        switch (this.data.type.toUpperCase()) {
          case this.recaudosIni.toUpperCase():
            url= 'generarguia'
            break;
          case this.recaudos.toUpperCase():
            url= 'mispagos'
            break;
          case this.novedades.toUpperCase():
            url= 'novedades'
              break;
          case this.facturas.toUpperCase():
            url= 'mis-facturas'
              break;
          case this.recogidas.toUpperCase():
            // nombre de la url a que se redirige
            url= 'consultasolicitudrecogida'
              break;
        }
        return url
      },
      // Query params used by the target module to auto-query the referenced item
      redirectPage(id="", type=""){
        let location;
        if(type == "recogidas"){
          // Pickup number travels in its own field; the target view auto-queries with it
          const pickupNumber = this.data.pickupNumber;
          location = {
            name: this.setUrlRedirect(),
            ...(pickupNumber ? { query: { pickupNumber } } : {})
          };
        }
        else if(id && type != "facturas"){
          location = {
            name: this.setUrlRedirect(),
            query: { id: id }
          };
        }
        else if(id && type == "facturas"){
          location = {
            name: this.setUrlRedirect(),
            query: {
              id: id,
              unidadNegocio: this.data.unidadNegocio,
              cuenta: this.data.cuenta
            }
          };
        }
        else {
          location = { name: this.setUrlRedirect() };
        }
        // Clicking a notification whose target is the current URL is a no-op; pushing it
        // would reject with a duplicated-navigation error
        if (this.$router.resolve(location).route.fullPath === this.$route.fullPath) return;
        this.$router.push(location);
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '@/scss/variables';

  .notify-card {
    background-color: $cwhite;
    border-radius: 14px;
    border: 1px solid $c4;
    width: 100%;
    height: auto;
    padding: 22px 17px;
    color: $cblack;
    font-weight: 500;

    .header-notify {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .notify-type {
        padding: 6px 12px;
        border-radius: 7px;
        background-color: $c3;
        display: flex;
        gap: 6px;
        align-items: center;
        font-size: 14px;

        img {
          width: 19px;
        }
      }

      .close-notify {
        cursor: pointer;
        img {
          width: 16px;
          height: 16px;
        }
      }
    }

    .body-notify {
      margin-top: 15px;
      display: flex;
      flex-direction: column;
      font-size: 16px;

      .action-notify {
        padding: 10px;
        margin-top: 10px;
        background-color: $c4;
        border-radius: 50px;
        display: flex;
        justify-content: center;
        transition: 0.3s;
        cursor: pointer;

        &:hover {
          background-color: $c3;
        }
      }
    }
  }
</style>